module.exports = __webpack_public_path__ + "./assets/img/team_3.edfbb631.png";